import axios from "axios";

export const state = {
    insuranceledgers: [],
};

export const getters = {
    insuranceledgers: state => state.insuranceledgers,
};

export const mutations = {
    setInsuranceLedgers(insuranceledgers, newValue) { state.insuranceledgers = newValue},
};

export const actions = {
    fetchInsuranceLedgers({ commit }) {
        axios.get('/insuranceledgers').then(res => {
            commit('setInsuranceLedgers', res.data.ledgers)
        })
    },
    filterInsuranceLedgers({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterinsuranceledgers";
        axios.post(url, formData).then((response) => {
            commit('setInsuranceLedgers', response.data.ledgers)
        })
    },
};
